import { Grid, Text } from '@approvalmax/ui/src/components';
import { PersonVerificationDetails } from 'shared/components/(wallets)/kyc/PersonVerificationDetails';

import { SendInvitation } from '../SendInvitation/SendInvitation';
import { messages } from './DetailsStep.messages';

export const DetailsStep = () => {
    return (
        <>
            <Grid gap={16}>
                <SendInvitation step='details' />

                <Text font='headline' fontSize='xxsmall' fontWeight='medium'>
                    {messages.personalDetails}
                </Text>
            </Grid>

            <PersonVerificationDetails />
        </>
    );
};

DetailsStep.displayName = 'DetailsStep';
